import { defineStore } from 'pinia';
import { api } from '../boot/axios';

export const useMessageStore = defineStore('message', {
  persist: true,

  state: () => ({
    messageIsLoading: false,
    messagesAreLoading: false,
    messages: [] // Various messages that may have been downloaded.
  }),

  getters: {
    getMessagesByActivationId: (state) => {
      return (activationId) => state.messages.filter(message => message.activationID == activationId) || [] // eslint-disable-line eqeqeq
    },
    getMessageByAttachmentId: (state) => (attachmentId) => {
      return state.messages.find(message => message.activationAttachmentID == attachmentId) || [] // eslint-disable-line eqeqeq
    },
    getMessagesPending: (state) => {
      return state.messages.filter(message => message.isSent === false)
    },
    getMessagingDoctorsByActivationID: (state) => (activationId) => {
      const doctors = []
      const m = state.messages.filter(message => message.activationID === activationId) || []
      for (let i = 0; i < m.length; i++) {
        if (m[i].employeeTitle === 'Dr.') {
          if (doctors.some(message => message.employeeID === m[i].employeeID)) {

          } else {
            const doctor = {
              employeeID: m[i].employeeID,
              employeeName: m[i].employeeTitle + m[i].firstname + ' ' + m[i].surname + ', ' + 'Messaging'
            }
            doctors.push(doctor)
          }
        }
      }
      return doctors
    }
  },

  actions: {
    deleteAttachmentMessage (activationAttachmentID) {
      for (let i = 0; i < this.messages.length; i++) {
        if (this.messages[i].activationAttachmentID === activationAttachmentID) {
          this.messages.splice(i, 1)
          break
        }
      }
    },
    fetchMessages (activationId) {
      // TODO: Check if online first
      // if (rootGetters.isOnline) {
      this.messagesAreLoading = true
      return api
        .get('/api/v1/activations/' + activationId + '/messages/')
        .then(response => {
          this.saveMessagesLocally(response.data)
        }).catch(err => {
          // TODO: Send the error to our Error endpoint for logging.
          console.error(err)
        })
        .finally(() => {
          this.messagesAreLoading = false
        })
      // }
    },
    saveMessagesLocally (messages) {
      for (let m = 0; m < messages.length; m++) {
        const message = messages[m]
        // Check to see if the new message is already present
        let present = false
        for (let i = 0; i < this.messages.length; i++) {
          if (this.messages[i].activationMessageID === message.activationMessageID) {
            present = true
            this.messages[i] = { ...this.messages[i], ...message }
            break // We can stop
          }
        }
        // If not already present, add them to our store.
        if (!present) {
          this.messages.push(message)
        }
      }
    },
    async markMessageRead (readMessage) {
      const requestData = {
        activationMessageID: readMessage.activationMessageID,
        activationID: readMessage.activationID,
        patientRecordMedicationID: readMessage.patientRecordMedicationID,
        patientRecordIterationID: readMessage.patientRecordIterationID,
        standardFormAnswerID: readMessage.standardFormAnswerID,
        attachmentType: readMessage.attachmentType,
        attachmentID: readMessage.attachmentID
      }
      await api.post('/api/v1/message-status', requestData)
      const newMessage = { ...readMessage, isRead: true }
      if (newMessage.activationMessageID) {
        this.saveUpdateFromServer(readMessage, newMessage)
        // commit(MESSAGE_SAVE_MESSAGE_SUCCESS, { localMessage: readMessage, serverMessage: newMessage })
        // dispatch(CASE_DECREMENT_UNREAD, readMessage.activationID)
        /*
      } else if (newMessage.activationID) {
        commit(CASE_PUT_ACTIVATION_SUCCESS, newMessage)
      } else if (newMessage.attachmentID) {
        commit(ACTIVATION_GET_ATTACHMENT_SUCCESS, newMessage)
      } else if (newMessage.patientRecordMedicationID) {
        commit(CASE_ADD_PRESCRIPTION_SUCCESS, newMessage)
      } else if (newMessage.patientRecordIterationID) {
        commit(CASE_SAVE_ITERATION, newMessage)
      } else if (newMessage.standardFormAnswerID) {
        commit(CASE_ADD_STANDARD_FORM_SUCCESS, newMessage)
         */
      }
    },
    async saveMessage (localMessage) {
      this.messages.push(localMessage)
      // TODO: watch for online
      await this.postMessage(localMessage)
    },
    saveUpdateFromServer (localMessage, serverMessage) {
      // remove the old one
      for (let i = 0; i < this.messages.length; i++) {
        if (this.messages[i].activationMessageID === localMessage.activationMessageID) {
          this.messages.splice(i, 1)
        }
      }
      // check if the new one already exists
      let existing = this.messages.find(existing => existing.activationMessageID === serverMessage.activationMessageID)
      if (existing) {
        existing = { ...existing, ...serverMessage }
      } else {
        // add the new one
        this.messages.push(serverMessage)
      }
    },
    async sync () {
      // Get any pending messages that are in the store
      const pending = this.getMessagesPending
      // Send them to the server.
      for (let m of pending) {
        await this.postMessage(m)
      }
    },
    async postMessage(message) {
      try {
        const response = await api.post('/api/v1/activations/' + message.activationID + '/messages/', message)
        const serverMessage = response.data
        this.saveUpdateFromServer(message, serverMessage)
      } catch (err) {
        console.log('error saving message: ' + err)
      }
    }
  }

})
